import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useRef } from 'react';
import useDuperbrowseLink from '../hooks/useDuperbrowseLink';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { getDeviationUrl } from '../../DeviationViews/_helpers';
import { useBiDataForDeviationLink } from './useBiDataForDeviationLink';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
const DeviationLink = (_param)=>{
    var { deviation , onClick , children , extraBiData , disableScrollRestoration , canLinkToStash =false  } = _param, restProps = _object_without_properties(_param, [
        "deviation",
        "onClick",
        "children",
        "extraBiData",
        "disableScrollRestoration",
        "canLinkToStash"
    ]);
    const ref = useRef();
    const linkBiData = useBiDataForDeviationLink(deviation, extraBiData);
    const onDuperbrowseClick = useDuperbrowseLink(getDeviationEntityId(deviation), ref, onClick, disableScrollRestoration);
    if (!deviation.isPublished && !canLinkToStash) {
        return /*#__PURE__*/ React.createElement("span", {
            className: restProps.className
        }, children);
    }
    return /*#__PURE__*/ React.createElement(BiLink, _extends({
        "data-hook": BiDataHook.DEVIATION_LINK,
        href: getDeviationUrl(deviation),
        biData: linkBiData,
        onClick: onDuperbrowseClick,
        // the undefined here is needed to keep react typings from going nuts
        innerRef: (node)=>ref.current = node || undefined
    }, restProps), children);
};
DeviationLink.displayName = 'DeviationLink';
export default DeviationLink;
